// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
    GESTION_OPERATIVA_GET_GASTOS_DE_ENTREGA_CHECKED,
    GESTION_OPERATIVA_RESTORE_PATENTAMIENTO_INITIAL,
  } from './constants';
  
  export function getGastosDeEntregaChecked(bool) {
      return {
        type: GESTION_OPERATIVA_GET_GASTOS_DE_ENTREGA_CHECKED,
        data: {
          client_license_plate: bool,
          will_get_costs: true
        },
      };
    }

  export function restorePatentamientoInitial() {
    return {
      type: GESTION_OPERATIVA_RESTORE_PATENTAMIENTO_INITIAL,
    };
  }
  
  export function reducer(state, action) {
    if (action.type === GESTION_OPERATIVA_RESTORE_PATENTAMIENTO_INITIAL) {
      const initialChecked = !!state.initial_client_license_plate;
      return {
        ...state,
        delivery_costs_manually_edited: false,
        sale: {
          ...state.sale,
          client_license_plate: initialChecked,
          patentamientoCheck: initialChecked,
          delivery_costs: state.initial_delivery_costs,
          delivery_costs_original: state.initial_delivery_costs_original,
        },
      };
    }
    if (action.type === GESTION_OPERATIVA_GET_GASTOS_DE_ENTREGA_CHECKED) {
        const isCheckOn = action.data.client_license_plate;
        return {
          ...state,
          will_get_costs: action.data.will_get_costs,
          delivery_costs_manually_edited: false,
          sale: {
            ...state.sale,
            client_license_plate: isCheckOn,
            patentamientoCheck: isCheckOn,
            ...(isCheckOn
              ? {
                  delivery_costs_original: state.sale.delivery_costs_original ?? state.sale.delivery_costs
                }
              : {
                  delivery_costs: state.sale.delivery_costs_original ?? state.sale.delivery_costs,
                  delivery_costs_original: null
                }
            )
          }
        };
    }
    else {
        return state;
    }      
  }
  